import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30fd802a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["form-check form-switch form-check-custom form-check-solid form-check-danger", { 'no-click': _ctx.isReadOnly || _ctx.attributes.disabled }])
    }, [
      _withDirectives(_createElementVNode("input", _mergeProps({
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        type: "checkbox",
        class: "form-check-input"
      }, _ctx.attributes, {
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleOnChange && _ctx.handleOnChange(...args)))
      }), null, 16), [
        [_vModelCheckbox, _ctx.value]
      ])
    ], 2)
  ]))
}